import React from "react";
import RevealSection from "../RevealSection";

const STEPS = [
  {
    num: "01",
    title: "Upload your resume",
    body: "GuMi reads your entire career: skills, leadership signals, and scale depth.",
  },
  {
    num: "02",
    title: "Paste any job URL",
    body: "Works with Greenhouse, Lever, Ashby and Workday links. Anywhere else, paste the job description.",
  },
  {
    num: "03",
    title: "Get your answer",
    body: "Fit score, freshness, company health, callback odds. Honest. Usually in under 30 seconds.",
  },
];

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      style={{ background: "#f5f4f0", padding: "100px 24px" }}
    >
      <div style={{ textAlign: "center" }}>
        <RevealSection>
          <p
            className="font-body"
            style={{
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              color: "#1D9E75",
              marginBottom: 16,
            }}
          >
            HOW IT WORKS
          </p>
        </RevealSection>

        <RevealSection>
          <h2
            className="font-heading"
            style={{ fontSize: "clamp(32px, 5vw, 52px)", fontWeight: 700, letterSpacing: "-1px", lineHeight: 1.1, color: "#1a1a18" }}
          >
            Three steps. One honest answer.
          </h2>
        </RevealSection>
      </div>

      <div
        className="how-it-works-grid"
        style={{
          maxWidth: 900,
          margin: "56px auto 0",
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: 40,
        }}
      >
        {STEPS.map((s, i) => (
          <RevealSection key={s.num} delay={i + 1}>
            <span
              className="font-heading tabular"
              style={{ fontSize: 48, fontWeight: 700, color: "#1D9E75", opacity: 0.3, lineHeight: 1, display: "block" }}
            >
              {s.num}
            </span>
            <h3
              className="font-heading"
              style={{ fontSize: 17, fontWeight: 600, margin: "8px 0 4px", color: "#1a1a18" }}
            >
              {s.title}
            </h3>
            <p className="font-body" style={{ fontSize: 16, color: "#5f5e5a", lineHeight: 1.6 }}>
              {s.body}
            </p>
          </RevealSection>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
